// extracted by css-extract-rspack-plugin
export default {"cls1":"PreprintSuggestionsStep-cls1_k7x","cls2":"PreprintSuggestionsStep-cls2_oKj PreprintSuggestionsStep-cls1_k7x"};